import { render } from "./BCMockUp.vue?vue&type=template&id=ec2edb8a"
import script from "./BCMockUp.vue?vue&type=script&lang=js"
export * from "./BCMockUp.vue?vue&type=script&lang=js"

import "./BCMockUp.vue?vue&type=style&index=0&id=ec2edb8a&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__